module.exports = __webpack_public_path__ + "img/3d_demo.86e5f562.png";